import React, { useState } from "react"
import { api, ApiError } from "../../lib/api"
import { Button } from "../ui/Button"
import { useToast } from "../ui/Toast"

/** Aviso pra confirmar o e-mail (e-mail/senha não confirmado). Libera o nivelamento. */
export function ConfirmEmailBanner() {
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const { toast } = useToast()

  async function resend() {
    setSending(true)
    try {
      await api.post("/api/me/resend_confirmation")
      setSent(true)
      toast("E-mail de confirmação reenviado. Confira sua caixa (e o spam).", "success")
    } catch (e) {
      // Cooldown (429): não é erro do usuário — avisa e trava o botão como "enviado".
      if (e instanceof ApiError && e.code === "resend_cooldown") {
        setSent(true)
        toast(e.message, "info")
      } else {
        toast(e instanceof ApiError ? e.message : "Não foi possível reenviar agora.", "error")
      }
    } finally {
      setSending(false)
    }
  }

  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-gold-400 bg-gold-50/70 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <svg viewBox="0 0 24 24" className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l9 6 9-6M5 5h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z" />
        </svg>
        <div>
          <p className="text-sm font-semibold text-navy-900">Confirme seu e-mail pra liberar seu diagnóstico</p>
          <p className="text-xs text-navy-500">Enviamos um link de confirmação. Não achou? Confira o spam ou reenvie.</p>
        </div>
      </div>
      <Button variant="gold" size="sm" onClick={() => void resend()} disabled={sending || sent} className="shrink-0">
        {sent ? "E-mail enviado ✓" : sending ? "Enviando..." : "Reenviar e-mail"}
      </Button>
    </div>
  )
}
